import { notification } from 'antd';
import API from '../api/jongjonan';

/**
 * Constants
 */

export const FETCHING = 'instansi/FETCHING';
export const FETCHING_OK = 'instansi/FETCHING_OK';
export const FETCHING_FAILED = 'instansi/FETCHING_FAILED';

/**
 * Action Creators
 */
export function fetchInstansi() {
    return async (dispatch) => {
        dispatch({ type: FETCHING });

        try {
            const instansi = await API.fetchInstansi();
            dispatch({
                type: FETCHING_OK,
                payload: instansi.data,
            });
        } catch (err) {
            dispatch({
                type: FETCHING_FAILED,
                err: err.response || err.message
            });
            notification.error({
                message: 'Error',
                description: err.message,
            });
        }
    }
}

/**
 * Reducer
 */
const initialState = {
    error: false,
    isLoading: false,
    data: [],
};

export default function instansi(state = initialState, action) {
    switch (action.type) {
        case FETCHING:
            return {
                ...state,
                isLoading: true,
                error: false,
            };

        case FETCHING_OK:
            return {
                isLoading: false,
                data: action.payload,
                error: false,
            };

        case FETCHING_FAILED:
            return {
                isLoading: false,
                data: [],
                error: action.err,
            };

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/modules/instansi.js